import pick from 'lodash/pick';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { toastError } from 'src/actions/toast';

const imitateUser: sharedTypes.AppThunk =
  ({ orgId, userId }) =>
  async (dispatch, getState, { gateways, stores }) => {
    try {
      const auth = await gateways.token.add({ orgId, userId });
      const claims = pick(auth, ['activatedAt', 'exp', 'iat', 'orgId', 'roleIds', 'userId', 'saganUser', 'scope']);
      stores.auth.set({ claims });
      window.location.replace('/');
    } catch (err) {
      dispatch(toastError('Unable to impersonate user'));
    }
  };

export default imitateUser;
